module.exports = __webpack_public_path__ + "static/media/remove.64398169.svg";